export const dashboardChunks = {
  dashboard: "dashboard",
};

export const datasetsChunks = {
  datasets: "datasets",
  new: "new",
  type: ":type",
  details: ":id",
  preview: "preview",
  visualize: "visualize",
  train: "train",
  predict: "predict/:execution_id",
  usDeploy: "us-deployment/:execution_id",
  qcDeploy: "qc-deployment/:execution_id",
};

export const assetsChunks = {
  assets: "assets",
  new: "new",
  details: ":id",
};

export const monitoringChunks = {
  monitoring: "monitoring",
  qc: "qc",
  qcBatchPrediction: "batch-prediction",
  qcBatchPredictionMonitor: ":monitorId",
  imageDetails: "image-details",
  alerts: "alerts",
  alertsCreate: "create",
  alertsEdit: ":alertId/edit",
  qcRealTime: "real-time",
  qcRealTimeCameras: "cameras",
  qcRealTimeCameraMonitor: ":id",
  qcRealTimeCameraGroupMonitor: "group/:id",
  qcRealTimeDataSources: "data-sources",
  qcRealTimeDatasourceMonitor: ":id",
  machineMonitor: ":machineModelId",
  alarms: "alarms",
  analytics: "analytics",
  data: "data/:dataId",
  assigments: "assignments",
  stats: "stats",
};

export const batchPredictionChunks = {
  batchPrediction: "batch-prediction",
  create: "create/:batchMode",
  results: ":execId/results",
  imageDetails: "image-details",
};

export const connectorsChunks = {
  connectors: "connectors",
  create: "create",
};

export const applicationsChunks = {
  application: "manage-applications",
  create: "create",
  details: ":appId",
};

export const adminDashboardChunks = {
  adminDashboard: "admin-dashboard",
  users: "users",
  userDetails: ":id",
  userStatistics: "statistics",
  orgs: "organizations",
  orgCreate: "create",
  orgDetails: ":id",
  orgStatistics: "statistics",
  roles: "roles",
  resources: "resources",
  alerts: "alerts",
  alertsCreate: "create",
  alertsEdit: ":id/edit",
};

export const settingsChunks = {
  settings: "settings",
  team: "team",
  orgStatistics: "organization/statistics/:id",
  userStatistics: "user/statistics/:id",
  userDetails: ":id",
  invitations: "invitations",
  modelsList: "models-list",
};

export const machinesChunks = {
  machines: "machines",
  qc: "qc",
  qcDetails: "details/:cameraId",
  qcEdit: "edit/:cameraId",
  qcCameraWizard: "wizard",
  qcEditCameraWizard: "wizard/:cameraId",
};
export const executionChunk = "execution-details/:execId";
